const CACHE_KEY = 'cachedCartContent';
const CACHE_DURATION = 120000; // 2 minutes in milliseconds

export function getCachedCart() {
  const cached = localStorage.getItem(CACHE_KEY);
  if (!cached) {
    return '';
  }
  const { data, expiryTime } = JSON.parse(cached);
  if (new Date().getTime() > expiryTime) {
    clearCachedCart();
    return '';
  }
  return data;
}

export function setCachedCart(data:string) {
  if ((!data && data !== '') || window._be_platform === 'bifrost') {
    return;
  }
  const expiryTime = new Date().getTime() + CACHE_DURATION;
  localStorage.setItem(CACHE_KEY, JSON.stringify({ data, expiryTime }));
}

export function clearCachedCart() {
  localStorage.removeItem(CACHE_KEY);
}